import { gql } from "../__generated__/gql";

gql(`
    fragment CCTFields on CCT {
        id
        cctEditionId
        cctContractId
        cctVersionId
        name
        hoursPerWeek
        active
        intercomMainArticleId
        intercomHelpArticleId
        cctUrl
    }
`);

gql(`
    fragment CCTDetailsFieldValuesFields on CCTDetailsFieldValue {
        value
        criteriaListEntryId
        criteriaStructureId
        autoSelected
    }
`);

gql(`
    fragment CCTDetailsFieldFullValueFields on CCTDetailsFieldFullValue {
        readableValues {
            question
            answer
        }
        tempdataCallValues {
            ...CCTDetailsFieldValuesFields
        }
    }
`);

gql(`
    fragment CCTDetailsFieldFields on CCTDetailsField {
        uniqName
        name
        id
        values {
            ...CCTDetailsFieldValuesFields
        }
    }
`);

export const GET_CCT_BY_EDITION_BY = gql(`
    query GetCct($cctEditionId: String!) {
        getCctByEditionId(cctEditionId: $cctEditionId) {
            ...CCTFields
        }
    }
`);

export const FIND_CCT = gql(`
    query FindCct($stateCode: String, $offset: Int, $limit: Int) {
        findCct(stateCode: $stateCode, offset: $offset, limit: $limit) {
            elements {
                ...CCTFields
            }
            pageInfo {
                ...PageInfoFields
            }
        }
    }
`);

// field is a recursive model. This query
export const GET_CCT_DETAILS_FIELDS = gql(`
    query GetCctDetailsFields($cctEditionId: String!) {
        getCctDetailsFields(cctEditionId: $cctEditionId) {
            ...CCTDetailsFieldFields
            children {
                ...CCTDetailsFieldFields
                children {
                    ...CCTDetailsFieldFields
                    children {
                        ...CCTDetailsFieldFields
                        children {
                            ...CCTDetailsFieldFields
                        }
                    }
                }
            }
        }
    }
`);

export const GET_CCT_DETAILS_FIELD_VALUES = gql(`
    query GetCctDetailsFieldValues(
        $cctEditionId: String!
        $criteriaStructureId: Int!
        $parentValue: CCTDetailsFieldValueInput!
    ) {
        getCctDetailsFieldValues(
            cctEditionId: $cctEditionId
            criteriaStructureId: $criteriaStructureId
            parentValue: $parentValue
        ) {
            ...CCTDetailsFieldValuesFields
        }
    }
`);
